import HeroSection from '@/pages/home/components/HeroSection';
import AboutSection from '@/pages/home/components/AboutSection';
import PrinciplesSection from '@/pages/home/components/PrinciplesSection';
import ApproachSection from '@/pages/home/components/ApproachSection';
import ContactSection from '@/pages/home/components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <PrinciplesSection />
      <ApproachSection />
      <ContactSection />
    </main>
  );
}